import { Link } from "react-router-dom";
import { DIRECT_DIRECTORY } from "./districts";

export function DirectDirectory() {
  return <nav id="direct-directory" className="world-directory" aria-label="Direct Directory">
    <h2>Direct Directory</h2>
    <p>Every destination remains available without the world image.</p>
    <ul>{DIRECT_DIRECTORY.map((entry) => {
      const family = "family" in entry ? entry.family : undefined;
      return <li key={entry.path}><Link to={family ?? entry.path}>{entry.label}</Link>{family && <small> dynamic route</small>}</li>;
    })}</ul>
  </nav>;
}
